import { token } from '@atlaskit/tokens';
import React from 'react';

import { ViewIconColor, ViewIconSize } from '../types';

import { DirectoryMoreViewsIconWrapper } from './style';

const colors = {
  teal: {
    icon: token('color.icon.accent.teal'),
    background: token('color.background.accent.teal.subtlest'),
  },
  yellow: {
    icon: token('color.icon.accent.yellow'),
    background: token('color.background.accent.yellow.subtlest'),
  },
  purple: {
    icon: token('color.icon.accent.purple'),
    background: token('color.background.accent.purple.subtlest'),
  },
  orange: {
    icon: token('color.icon.accent.orange'),
    background: token('color.background.accent.orange.subtlest'),
  },
  red: {
    icon: token('color.icon.accent.red'),
    background: token('color.background.accent.red.subtlest'),
  },
  green: {
    icon: token('color.icon.accent.green'),
    background: token('color.background.accent.green.subtlest'),
  },
  magenta: {
    icon: token('color.icon.accent.magenta'),
    background: token('color.background.accent.magenta.subtlest'),
  },
};

const getColorFromUuid = (uuid: string) => {
  const colorNames = Object.keys(colors) as ViewIconColor[];
  const uuidAsInt = Math.abs(uuid.split('-').reduce((acc, val) => acc + parseInt(val, 16), 0));
  const index = uuidAsInt % colorNames.length;
  return colorNames[index];
};

export const ViewIcon = ({ uuid, size = 'small' }: { uuid?: string | null; size?: ViewIconSize }) => {
  const color = uuid ? getColorFromUuid(uuid) : 'teal';
  const foregroundColor = colors[color].icon;
  const backgroundColor = colors[color].background;

  return (
    <DirectoryMoreViewsIconWrapper foregroundColor={foregroundColor} backgroundColor={backgroundColor} size={size}>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.16667 12.5L4.16667 4.16667L13.3333 4.16667V12.5H4.16667ZM4.16667 14.1667C3.24619 14.1667 2.5 13.4205 2.5 12.5V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H13.3333C14.2538 2.5 15 3.24619 15 4.16667V12.5C15 13.4205 14.2538 14.1667 13.3333 14.1667L4.16667 14.1667ZM9.16667 5C8.70643 5 8.33333 5.3731 8.33333 5.83333C8.33333 6.29357 8.70643 6.66667 9.16667 6.66667H11.6667C12.1269 6.66667 12.5 6.29357 12.5 5.83333C12.5 5.3731 12.1269 5 11.6667 5H9.16667ZM8.33333 8.33333C8.33333 7.8731 8.70643 7.5 9.16667 7.5H11.6667C12.1269 7.5 12.5 7.8731 12.5 8.33333C12.5 8.79357 12.1269 9.16667 11.6667 9.16667H9.16667C8.70643 9.16667 8.33333 8.79357 8.33333 8.33333ZM8.33333 10.8333C8.33333 10.3731 8.70643 10 9.16667 10H10.8333C11.2936 10 11.6667 10.3731 11.6667 10.8333C11.6667 11.2936 11.2936 11.6667 10.8333 11.6667H9.16667C8.70643 11.6667 8.33333 11.2936 8.33333 10.8333ZM5 10.8333C5 10.3731 5.3731 10 5.83333 10H6.66667C7.1269 10 7.5 10.3731 7.5 10.8333C7.5 11.2936 7.1269 11.6667 6.66667 11.6667H5.83333C5.3731 11.6667 5 11.2936 5 10.8333ZM5.83333 7.5C5.3731 7.5 5 7.8731 5 8.33333C5 8.79357 5.3731 9.16667 5.83333 9.16667H6.66667C7.1269 9.16667 7.5 8.79357 7.5 8.33333C7.5 7.8731 7.1269 7.5 6.66667 7.5H5.83333ZM5 5.83333C5 5.3731 5.3731 5 5.83333 5H6.66667C7.1269 5 7.5 5.3731 7.5 5.83333C7.5 6.29357 7.1269 6.66667 6.66667 6.66667H5.83333C5.3731 6.66667 5 6.29357 5 5.83333ZM5 15C5 15.9205 5.74619 16.6667 6.66667 16.6667L15.8333 16.6667C16.7538 16.6667 17.5 15.9205 17.5 15V6.66667C17.5 5.74619 16.7538 5 15.8333 5L15.8333 15L5 15Z"
        />
      </svg>
    </DirectoryMoreViewsIconWrapper>
  );
};
